import _createForOfIteratorHelper from "/root/Etro/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import { createStyles, rem, getSize } from '@mantine/styles';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var ACTION_ICON_VARIANTS = ["subtle", "filled", "outline", "light", "default", "transparent", "gradient"];
var sizes = {
  xs: rem(18),
  sm: rem(22),
  md: rem(28),
  lg: rem(34),
  xl: rem(44)
};

function getVariantStyles(_ref) {
  var variant = _ref.variant,
      theme = _ref.theme,
      color = _ref.color,
      gradient = _ref.gradient;
  var colors = theme.fn.variant({
    color,
    variant,
    gradient
  });

  if (variant === "gradient") {
    return {
      border: 0,
      backgroundImage: colors.background,
      color: colors.color,
      "&:hover": theme.fn.hover({
        backgroundSize: "200%"
      })
    };
  }

  if (ACTION_ICON_VARIANTS.includes(variant)) {
    return __spreadValues({
      border: "".concat(rem(1), " solid ").concat(colors.border),
      backgroundColor: colors.background,
      color: colors.color
    }, theme.fn.hover({
      backgroundColor: colors.hover
    }));
  }

  return null;
}

var useStyles = createStyles(function (theme, _ref2, _ref3) {
  var radius = _ref2.radius,
      color = _ref2.color,
      gradient = _ref2.gradient;
  var variant = _ref3.variant,
      size = _ref3.size;
  return {
    root: __spreadProps(__spreadValues({
      position: "relative",
      borderRadius: theme.fn.radius(radius),
      padding: 0,
      lineHeight: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: getSize({
        size,
        sizes
      }),
      minHeight: getSize({
        size,
        sizes
      }),
      width: getSize({
        size,
        sizes
      }),
      minWidth: getSize({
        size,
        sizes
      })
    }, getVariantStyles({
      variant,
      theme,
      color,
      gradient
    })), {
      "&:active": theme.activeStyles,
      "& [data-action-icon-loader]": {
        maxWidth: "70%"
      },
      "&:disabled, &[data-disabled]": {
        color: theme.colors.gray[theme.colorScheme === "dark" ? 6 : 4],
        cursor: "not-allowed",
        backgroundColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
        borderColor: variant === "transparent" ? void 0 : theme.fn.themeColor("gray", theme.colorScheme === "dark" ? 8 : 1),
        backgroundImage: "none",
        pointerEvents: "none",
        "&:active": {
          transform: "none"
        }
      },
      "&[data-loading]": {
        pointerEvents: "none",
        "&::before": __spreadProps(__spreadValues({
          content: '""'
        }, theme.fn.cover(rem(-1))), {
          backgroundColor: theme.colorScheme === "dark" ? theme.fn.rgba(theme.colors.dark[7], 0.5) : "rgba(255, 255, 255, .5)",
          borderRadius: theme.fn.radius(radius),
          cursor: "not-allowed"
        })
      }
    })
  };
});
export default useStyles;
export { ACTION_ICON_VARIANTS, sizes };